// Critical keywords - partial match (contains check)
const CRITICAL_KEYWORDS_TR = [
  "intihar", "öldür", "kafam", "kafama", "sık", "sıkacağ", "sıkmak",
  "atla", "atlayacağ", "zarar ver", "ölmek", "yaşamak istem", 
  "hayatıma son", "yok et", "dayanamı", "bırak git" , "kendimi keseceğim", "kendimi kes", "kesmek istiyorum kendimi"
]

const CRITICAL_KEYWORDS_EN = [
  "suicid", "kill my", "end my life", "want to die", "shoot my",
  "jump off", "hang my", "self harm", "hurt my", "don't want to live",
  "can't take", "give up on life", "end it all"
]

export function checkForCrisisKeywords(text: string, language: "tr" | "en"): boolean {
  const keywords = language === "tr" ? CRITICAL_KEYWORDS_TR : CRITICAL_KEYWORDS_EN
  const lowerText = text.toLowerCase().trim()
  
  // Partial match - checks if text CONTAINS any keyword
  return keywords.some(keyword => lowerText.includes(keyword.toLowerCase()))
}

export function shouldInterrupt(text: string, language: "tr" | "en"): boolean {
  return checkForCrisisKeywords(text, language)
}